export default
[
  {
    value: 'CA',
    name: 'Canada',
  },
  {
    value: 'BZ',
    name: 'Belize',
  },
  {
    value: 'BY',
    name: 'Belarus',
  },
  {
    value: 'CG',
    name: 'Congo',
  },
  {
    value: 'CF',
    name: 'Central African Republic',
  },
  {
    value: 'CI',
    name: "Cote D'Ivoire",
  },
  {
    value: 'CH',
    name: 'Switzerland',
  },
  {
    value: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  {
    value: 'CD',
    name: 'Congo, The Democratic Republic of the',
  },
  {
    value: 'CO',
    name: 'Colombia',
  },
  {
    value: 'CN',
    name: 'China',
  },
  {
    value: 'CK',
    name: 'Cook Islands',
  },
  {
    value: 'CM',
    name: 'Cameroon',
  },
  {
    value: 'CL',
    name: 'Chile',
  },
  {
    value: 'CV',
    name: 'Cape Verde',
  },
  {
    value: 'CY',
    name: 'Cyprus',
  },
  {
    value: 'CX',
    name: 'Christmas Island',
  },
  {
    value: 'CR',
    name: 'Costa Rica',
  },
  {
    value: 'CU',
    name: 'Cuba',
  },
  {
    value: 'CZ',
    name: 'Czech Republic',
  },
  {
    value: 'DJ',
    name: 'Djibouti',
  },
  {
    value: 'DE',
    name: 'Germany',
  },
  {
    value: 'DO',
    name: 'Dominican Republic',
  },
  {
    value: 'DK',
    name: 'Denmark',
  },
  {
    value: 'DM',
    name: 'Dominica',
  },
  {
    value: 'DZ',
    name: 'Algeria',
  },
  {
    value: 'AE',
    name: 'United Arab Emirates',
  },
  {
    value: 'AD',
    name: 'Andorra',
  },
  {
    value: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    value: 'AF',
    name: 'Afghanistan',
  },
  {
    value: 'AM',
    name: 'Armenia',
  },
  {
    value: 'AL',
    name: 'Albania',
  },
  {
    value: 'AO',
    name: 'Angola',
  },
  {
    value: 'AN',
    name: 'Netherlands Antilles',
  },
  {
    value: 'AI',
    name: 'Anguilla',
  },
  {
    value: 'AU',
    name: 'Australia',
  },
  {
    value: 'AT',
    name: 'Austria',
  },
  {
    value: 'AW',
    name: 'Aruba',
  },
  {
    value: 'AQ',
    name: 'Antarctica',
  },
  {
    value: 'AS',
    name: 'American Samoa',
  },
  {
    value: 'AR',
    name: 'Argentina',
  },
  {
    value: 'AX',
    name: 'Aland Islands',
  },
  {
    value: 'AZ',
    name: 'Azerbaijan',
  },
  {
    value: 'BF',
    name: 'Burkina Faso',
  },
  {
    value: 'BE',
    name: 'Belgium',
  },
  {
    value: 'BH',
    name: 'Bahrain',
  },
  {
    value: 'BG',
    name: 'Bulgaria',
  },
  {
    value: 'BB',
    name: 'Barbados',
  },
  {
    value: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    value: 'BD',
    name: 'Bangladesh',
  },
  {
    value: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    value: 'BM',
    name: 'Bermuda',
  },
  {
    value: 'BO',
    name: 'Bolivia',
  },
  {
    value: 'BJ',
    name: 'Benin',
  },
  {
    value: 'BI',
    name: 'Burundi',
  },
  {
    value: 'BL',
    name: 'Saint Barthelemy',
  },
  {
    value: 'BV',
    name: 'Bouvet Island',
  },
  {
    value: 'BW',
    name: 'Botswana',
  },
  {
    value: 'BR',
    name: 'Brazil',
  },
  {
    value: 'BT',
    name: 'Bhutan',
  },
  {
    value: 'BS',
    name: 'Bahamas',
  },
  {
    value: 'GB',
    name: 'United Kingdom',
  },
  {
    value: 'GE',
    name: 'Georgia',
  },
  {
    value: 'GD',
    name: 'Grenada',
  },
  {
    value: 'GA',
    name: 'Gabon',
  },
  {
    value: 'GM',
    name: 'Gambia',
  },
  {
    value: 'GL',
    name: 'Greenland',
  },
  {
    value: 'GG',
    name: 'Guernsey',
  },
  {
    value: 'GF',
    name: 'French Guiana',
  },
  {
    value: 'GI',
    name: 'Gibraltar',
  },
  {
    value: 'GH',
    name: 'Ghana',
  },
  {
    value: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
  },
  {
    value: 'GR',
    name: 'Greece',
  },
  {
    value: 'GU',
    name: 'Guam',
  },
  {
    value: 'GT',
    name: 'Guatemala',
  },
  {
    value: 'GN',
    name: 'Guinea',
  },
  {
    value: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    value: 'GP',
    name: 'Guadeloupe',
  },
  {
    value: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    value: 'GY',
    name: 'Guyana',
  },
  {
    value: 'HK',
    name: 'Hong Kong',
  },
  {
    value: 'HN',
    name: 'Honduras',
  },
  {
    value: 'HM',
    name: 'Heard Island and McDonald Islands',
  },
  {
    value: 'HT',
    name: 'Haiti',
  },
  {
    value: 'HU',
    name: 'Hungary',
  },
  {
    value: 'HR',
    name: 'Croatia',
  },
  {
    value: 'EC',
    name: 'Ecuador',
  },
  {
    value: 'EH',
    name: 'Western Sahara',
  },
  {
    value: 'EE',
    name: 'Estonia',
  },
  {
    value: 'EG',
    name: 'Egypt',
  },
  {
    value: 'ES',
    name: 'Spain',
  },
  {
    value: 'ER',
    name: 'Eritrea',
  },
  {
    value: 'ET',
    name: 'Ethiopia',
  },
  {
    value: 'FJ',
    name: 'Fiji',
  },
  {
    value: 'FI',
    name: 'Finland',
  },
  {
    value: 'FK',
    name: 'Falkland Islands (Malvinas)',
  },
  {
    value: 'FR',
    name: 'France',
  },
  {
    value: 'FM',
    name: 'Micronesia, Federated States of',
  },
  {
    value: 'FO',
    name: 'Faroe Islands',
  },
  {
    value: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    value: 'KI',
    name: 'Kiribati',
  },
  {
    value: 'KH',
    name: 'Cambodia',
  },
  {
    value: 'KE',
    name: 'Kenya',
  },
  {
    value: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    value: 'KP',
    name: "Korea, Democratic People's Republic of",
  },
  {
    value: 'KM',
    name: 'Comoros',
  },
  {
    value: 'KW',
    name: 'Kuwait',
  },
  {
    value: 'KY',
    name: 'Cayman Islands',
  },
  {
    value: 'KR',
    name: 'Korea, Republic of',
  },
  {
    value: 'LB',
    name: 'Lebanon',
  },
  {
    value: 'LA',
    name: "Lao People's Democratic Republic",
  },
  {
    value: 'KZ',
    name: 'Kazakstan',
  },
  {
    value: 'LI',
    name: 'Liechtenstein',
  },
  {
    value: 'LC',
    name: 'Saint Lucia',
  },
  {
    value: 'LR',
    name: 'Liberia',
  },
  {
    value: 'LK',
    name: 'Sri Lanka',
  },
  {
    value: 'LY',
    name: 'Libyan Arab Jamahiriya',
  },
  {
    value: 'LT',
    name: 'Lithuania',
  },
  {
    value: 'LS',
    name: 'Lesotho',
  },
  {
    value: 'LV',
    name: 'Latvia',
  },
  {
    value: 'LU',
    name: 'Luxembourg',
  },
  {
    value: 'MA',
    name: 'Morocco',
  },
  {
    value: 'MC',
    name: 'Monaco',
  },
  {
    value: 'IE',
    name: 'Ireland',
  },
  {
    value: 'ID',
    name: 'Indonesia',
  },
  {
    value: 'IM',
    name: 'Isle of Man',
  },
  {
    value: 'IL',
    name: 'Israel',
  },
  {
    value: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    value: 'IN',
    name: 'India',
  },
  {
    value: 'IT',
    name: 'Italy',
  },
  {
    value: 'IQ',
    name: 'Iraq',
  },
  {
    value: 'IS',
    name: 'Iceland',
  },
  {
    value: 'IR',
    name: 'Iran, Islamic Republic of',
  },
  {
    value: 'JE',
    name: 'Jersey',
  },
  {
    value: 'JM',
    name: 'Jamaica',
  },
  {
    value: 'JP',
    name: 'Japan',
  },
  {
    value: 'JO',
    name: 'Jordan',
  },
  {
    value: 'OM',
    name: 'Oman',
  },
  {
    value: 'PF',
    name: 'French Polynesia',
  },
  {
    value: 'PE',
    name: 'Peru',
  },
  {
    value: 'PA',
    name: 'Panama',
  },
  {
    value: 'PL',
    name: 'Poland',
  },
  {
    value: 'PK',
    name: 'Pakistan',
  },
  {
    value: 'PN',
    name: 'Pitcairn Islands',
  },
  {
    value: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    value: 'PH',
    name: 'Philippines',
  },
  {
    value: 'PG',
    name: 'Papua New Guinea',
  },
  {
    value: 'PT',
    name: 'Portugal',
  },
  {
    value: 'PS',
    name: 'Palestinian Territory',
  },
  {
    value: 'PR',
    name: 'Puerto Rico',
  },
  {
    value: 'PW',
    name: 'Palau',
  },
  {
    value: 'PY',
    name: 'Paraguay',
  },
  {
    value: 'QA',
    name: 'Qatar',
  },
  {
    value: 'MH',
    name: 'Marshall Islands',
  },
  {
    value: 'MK',
    name: 'Macedonia',
  },
  {
    value: 'ME',
    name: 'Montenegro',
  },
  {
    value: 'MD',
    name: 'Moldova, Republic of',
  },
  {
    value: 'MG',
    name: 'Madagascar',
  },
  {
    value: 'MF',
    name: 'Saint Martin',
  },
  {
    value: 'MQ',
    name: 'Martinique',
  },
  {
    value: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    value: 'MS',
    name: 'Montserrat',
  },
  {
    value: 'MR',
    name: 'Mauritania',
  },
  {
    value: 'MM',
    name: 'Myanmar',
  },
  {
    value: 'ML',
    name: 'Mali',
  },
  {
    value: 'MO',
    name: 'Macau',
  },
  {
    value: 'MN',
    name: 'Mongolia',
  },
  {
    value: 'MY',
    name: 'Malaysia',
  },
  {
    value: 'MX',
    name: 'Mexico',
  },
  {
    value: 'MZ',
    name: 'Mozambique',
  },
  {
    value: 'MU',
    name: 'Mauritius',
  },
  {
    value: 'MT',
    name: 'Malta',
  },
  {
    value: 'MW',
    name: 'Malawi',
  },
  {
    value: 'MV',
    name: 'Maldives',
  },
  {
    value: 'NA',
    name: 'Namibia',
  },
  {
    value: 'NC',
    name: 'New Caledonia',
  },
  {
    value: 'NI',
    name: 'Nicaragua',
  },
  {
    value: 'NL',
    name: 'Netherlands',
  },
  {
    value: 'NF',
    name: 'Norfolk Island',
  },
  {
    value: 'NE',
    name: 'Niger',
  },
  {
    value: 'NG',
    name: 'Nigeria',
  },
  {
    value: 'NR',
    name: 'Nauru',
  },
  {
    value: 'NP',
    name: 'Nepal',
  },
  {
    value: 'NO',
    name: 'Norway',
  },
  {
    value: 'NZ',
    name: 'New Zealand',
  },
  {
    value: 'NU',
    name: 'Niue',
  },
  {
    value: 'SO',
    name: 'Somalia',
  },
  {
    value: 'SN',
    name: 'Senegal',
  },
  {
    value: 'SK',
    name: 'Slovakia',
  },
  {
    value: 'SJ',
    name: 'Svalbard and Jan Mayen',
  },
  {
    value: 'SM',
    name: 'San Marino',
  },
  {
    value: 'SL',
    name: 'Sierra Leone',
  },
  {
    value: 'SV',
    name: 'El Salvador',
  },
  {
    value: 'SY',
    name: 'Syrian Arab Republic',
  },
  {
    value: 'SR',
    name: 'Suriname',
  },
  {
    value: 'ST',
    name: 'Sao Tome and Principe',
  },
  {
    value: 'SZ',
    name: 'Swaziland',
  },
  {
    value: 'TH',
    name: 'Thailand',
  },
  {
    value: 'TG',
    name: 'Togo',
  },
  {
    value: 'TJ',
    name: 'Tajikistan',
  },
  {
    value: 'TD',
    name: 'Chad',
  },
  {
    value: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    value: 'TF',
    name: 'French Southern Territories',
  },
  {
    value: 'TO',
    name: 'Tonga',
  },
  {
    value: 'TR',
    name: 'Turkey',
  },
  {
    value: 'TL',
    name: 'Timor-Leste',
  },
  {
    value: 'TK',
    name: 'Tokelau',
  },
  {
    value: 'TN',
    name: 'Tunisia',
  },
  {
    value: 'TM',
    name: 'Turkmenistan',
  },
  {
    value: 'TW',
    name: 'Taiwan',
  },
  {
    value: 'TZ',
    name: 'Tanzania, United Republic of',
  },
  {
    value: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    value: 'TV',
    name: 'Tuvalu',
  },
  {
    value: 'UA',
    name: 'Ukraine',
  },
  {
    value: 'UG',
    name: 'Uganda',
  },
  {
    value: 'RE',
    name: 'Reunion',
  },
  {
    value: 'RO',
    name: 'Romania',
  },
  {
    value: 'RU',
    name: 'Russian Federation',
  },
  {
    value: 'RW',
    name: 'Rwanda',
  },
  {
    value: 'RS',
    name: 'Serbia',
  },
  {
    value: 'SA',
    name: 'Saudi Arabia',
  },
  {
    value: 'SG',
    name: 'Singapore',
  },
  {
    value: 'SI',
    name: 'Slovenia',
  },
  {
    value: 'SH',
    name: 'Saint Helena',
  },
  {
    value: 'SC',
    name: 'Seychelles',
  },
  {
    value: 'SB',
    name: 'Solomon Islands',
  },
  {
    value: 'SE',
    name: 'Sweden',
  },
  {
    value: 'SD',
    name: 'Sudan',
  },
  {
    value: 'WS',
    name: 'Samoa',
  },
  {
    value: 'YE',
    name: 'Yemen',
  },
  {
    value: 'US',
    name: 'United States',
  },
  {
    value: 'UM',
    name: 'United States Minor Outlying Islands',
  },
  {
    value: 'UY',
    name: 'Uruguay',
  },
  {
    value: 'UZ',
    name: 'Uzbekistan',
  },
  {
    value: 'VA',
    name: 'Holy See (Vatican City State)',
  },
  {
    value: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    value: 'VI',
    name: 'Virgin Islands, U.S.',
  },
  {
    value: 'VE',
    name: 'Venezuela',
  },
  {
    value: 'VG',
    name: 'Virgin Islands, British',
  },
  {
    value: 'VN',
    name: 'Vietnam',
  },
  {
    value: 'VU',
    name: 'Vanuatu',
  },
  {
    value: 'WF',
    name: 'Wallis and Futuna',
  },
  {
    value: 'YT',
    name: 'Mayotte',
  },
  {
    value: 'ZA',
    name: 'South Africa',
  },
  {
    value: 'ZM',
    name: 'Zambia',
  },
  {
    value: 'ZW',
    name: 'Zimbabwe',
  },
];
